import React from 'react';
import SvgIcon from './SvgIcon';

const NbcNuclearBiologicalChemical = props => (
    <SvgIcon viewBox="0 0 26 24" {...props}>
        <path
            d="M22.2 5a3.034 3.034 0 00-3.067-3 3.077 3.077 0 00-1.847.62 5.391 5.391 0 00-8.572 0A3.077 3.077 0 006.867 2 3.034 3.034 0 003.8 5M3.8 5a2.251 2.251 0 100 4.5h2.7M22.2 5a2.251 2.251 0 110 4.5h-2.7M9.5 9v2.5M13 9v1.5M16.5 9v2.5M6.5 23.5c1.335 0 3-1.213 3-4M19.5 23.5c-1.335 0-3-1.213-3-4M13 18v5.5M17.25 17.5a2 2 0 000-4h-1.779a2.966 2.966 0 00-4.442 0H9.25a2 2 0 100 4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

NbcNuclearBiologicalChemical.displayName = 'NbcNuclearBiologicalChemicalIcon';

export default NbcNuclearBiologicalChemical;
